<template>
    <div>
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="德州" name="first">
                <div style="padding-top: 15px">
                    <el-button type="primary" @click="submitFunc('61')">应用(德州)</el-button>
                </div>
                <table v-loading="loading" class="common-table-et">
                    <tr>
                        <th>时间区间</th>
                        <th>爆桌数量</th>
                    </tr>
                    <tr v-for="item of etList" :key="item.startTime">
                        <td> {{item.startTime}} - {{item.endTime}}
                        </td>
                        <td><input style="width: 200px" class="el-input__inner" v-model="item.tableNum"/>
                        </td>
                    </tr>
                </table>
            </el-tab-pane>
            <el-tab-pane label="AOF" name="second">
                <div style="padding-top: 15px">
                    <el-button type="primary" @click="submitFunc('63')">应用(AOF)</el-button>
                </div>
                <table v-loading="loading" class="common-table-et">
                    <tr>
                        <th>时间区间</th>
                        <th>爆桌数量</th>
                    </tr>
                    <tr v-for="item of etList" :key="item.startTime">
                        <td> {{item.startTime}} - {{item.endTime}}
                        </td>
                        <td><input style="width: 200px" class="el-input__inner" v-model="item.tableNum"/>
                        </td>
                    </tr>
                </table>
            </el-tab-pane>
        </el-tabs>
        
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                activeName:'first'
            }
        },
        computed: {
            ...mapState('at', ['etList'])
        },
        created() {
            this.getList('61')
        },
        methods: {
            ...mapActions('at', ['getETDetail', 'updateET']),
            handleClick(tab) {
                console.log(tab.name);
                var self = this;
                if(tab.name == 'second'){
                    self.getList('63')
                }else{
                    self.getList('61')
                }
            },
            getList(roomPath) {
                this.loading = true;
                this.getETDetail(roomPath).then(() => {
                    this.loading = false;
                })
            },
            submitFunc(roomPath) {
                var data = {
                    etList:this.etList,
                    roomPath:roomPath
                }
                this.$confirm('确定要应用吗？', '提示', {
                    type: 'info'
                }).then(() => {
                    this.updateET(data).then(() => {
                        this.$message.success('应用成功');
                        this.getList(roomPath)
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>
